import { render, staticRenderFns } from "./VideoTrimModal.vue?vue&type=template&id=6f8bee3c&scoped=true"
import script from "./VideoTrimModal.vue?vue&type=script&lang=ts"
export * from "./VideoTrimModal.vue?vue&type=script&lang=ts"
import style0 from "./VideoTrimModal.vue?vue&type=style&index=0&id=6f8bee3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8bee3c",
  null
  
)

export default component.exports